// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RgTw","clinicsSelect":"styles_clinicsSelect__3cZQ_"};